import React from 'react';
import PropTypes from 'prop-types';
import Block from '../../../block/Block';
import CmsContent from '../../CmsContent';
import styles from './TextBlock.less';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import useDevice from '../../../hooks/use-device';
export var TextBlock = function TextBlock(_ref) {
  var data = _ref.data,
      textNodeWrapperElement = _ref.textNodeWrapperElement;
  var device = useDevice();

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var metadata = _ref2$component.metadata,
      _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var text = _ref2$component$conte.text,
      _ref2$componentTempla = _ref2.componentTemplate;
  _ref2$componentTempla = _ref2$componentTempla === void 0 ? {} : _ref2$componentTempla;
  var title = _ref2$componentTempla.title;

  var _ref3 = metadata || {},
      _ref3$textalignment = _ref3.textalignment;

  _ref3$textalignment = _ref3$textalignment === void 0 ? {} : _ref3$textalignment;
  var textposistion = _ref3$textalignment.Key,
      textposistionAlternative = _ref3$textalignment.key;
  var showTextColor = title === 'Body_Text_Enhanced' || title === 'Bottom_Text_Enhanced';
  var textStyle = getClasses({
    styles: styles,
    classes: ['textBlockWrapper', 'clearFloat', 'text-enhanced', "".concat(textposistion || textposistionAlternative), 'overlay', "".concat(showTextColor ? styles.defaultColor : '')],
    device: device
  });
  return text && /*#__PURE__*/React.createElement(Block, {
    "data-en": 'cms-text-block',
    className: textStyle
  }, /*#__PURE__*/React.createElement(CmsContent, {
    content: text,
    textNodeWrapperElement: textNodeWrapperElement
  }));
};
TextBlock.propTypes = {
  data: PropTypes.object.isRequired,
  textNodeWrapperElement: PropTypes.string
};
export default TextBlock;